import type { ReleaseCardData } from "@/components/release-card";
import { ReleaseCard } from "@/components/release-card";
import { cn } from "@/lib/utils";

interface WorkReleaseGridProps {
  isFetching: boolean;
  releases: ReleaseCardData[];
}

export function WorkReleaseGrid({ isFetching, releases }: WorkReleaseGridProps) {
  return (
    <ul
      aria-busy={isFetching}
      className={cn(
        "grid grid-cols-1 gap-3 transition-opacity md:grid-cols-3 md:gap-4",
        isFetching && "opacity-60",
      )}
    >
      {releases.map((release) => (
        // New cards (next page, other filter) fade in; kept cards don't re-animate.
        <li key={release.id} className="animate-in fade-in duration-200 motion-reduce:animate-none">
          <ReleaseCard release={release} variant="index" />
        </li>
      ))}
    </ul>
  );
}
